import React, { useEffect, useState } from "react";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Box, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { showInText } from "../../../../../utils/showInTextHelper";
import { useRendition } from "../../../../../RenditionContext";
import { appActions } from "../../../../../consts";
import {
  selectedQuestionHighlights,
  setSelectedTempHighlight
} from "../../../../../redux/interactionsSlice";

const useStyles = makeStyles((theme) => ({
  navigationCounter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    marginInline: theme.spacing(1)
  },
  navigationCounterTitle: {
    marginInline: theme.spacing(1)
  },
  barIcon: {
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)"
    }
  }
}));

const NavigateHighlights = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { rendition } = useRendition();

  const user_id = useSelector((state) => state.firebase.auth.uid);

  const questionHighlights = useSelector(selectedQuestionHighlights);
  const [currentHighlightIndex, setCurrentHighlightIndex] = useState(0);

  useEffect(() => {
    if (questionHighlights.length > 0) {
      setCurrentHighlightIndex(0);
      dispatch(setSelectedTempHighlight(questionHighlights[0]));
    } else {
      setCurrentHighlightIndex(-1);
      dispatch(setSelectedTempHighlight(null));
    }
  }, [questionHighlights, dispatch]);

  const navigateToHighlight = (index) => {
    if (
      questionHighlights.length === 0 ||
      index < 0 ||
      index >= questionHighlights.length
    ) {
      return;
    }
    const highlight = questionHighlights[index];
    dispatch(setSelectedTempHighlight(highlight));
    setCurrentHighlightIndex(index);
    showInText(appActions.SHOULD_LOG, highlight, user_id, rendition);
  };

  const navigateToPreviousHighlight = () => {
    if (questionHighlights.length === 0) return;

    const newIndex =
      currentHighlightIndex > 0
        ? currentHighlightIndex - 1
        : questionHighlights.length - 1;

    navigateToHighlight(newIndex);
  };

  const navigateToNextHighlight = () => {
    if (questionHighlights.length === 0) return;

    const newIndex =
      currentHighlightIndex < questionHighlights.length - 1
        ? currentHighlightIndex + 1
        : 0;

    navigateToHighlight(newIndex);
  };

  return (
    <Box className={classes.navigationCounter}>
      <Typography variant="body2" className={classes.navigationCounterTitle}>
        Highlights {currentHighlightIndex + 1} / {questionHighlights.length}
      </Typography>

      <Box>
        <IconButton
          size="medium"
          onClick={navigateToPreviousHighlight}
          className={classes.barIcon}>
          <KeyboardArrowUpOutlinedIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="medium"
          onClick={navigateToNextHighlight}
          className={classes.barIcon}>
          <KeyboardArrowDownOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default NavigateHighlights;
